module.exports = __webpack_public_path__ + "static/img/hzp@2x.4787575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/hzp@2x.png
// module id = c8HX
// module chunks = 1